import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Paper from '@material-ui/core/Paper';
import RegisterForm from './RegisterForm';
import * as actions from '../../actions';
import Footer from '../index/Footer';
import Header from '../index/Header';

const styles = {
	paper: {
		margin: 20,
		marginTop: 30,
		padding: 10,
		height: 700
	},
	container: {
		textAlign: 'center'
	},
	red: {
		color: 'darkred',
		fontSize: '1.2em'
	},
	button: {
		textAlign: 'center',
		marginTop: 20
	}
};

const Logo = styled.img`
	max-height: 80px;
	margin-top: 50px;

	@media (max-width: 600px) {
		max-height: 70px;
		margin-top: 10px;
	}
`;

const link = {
	color: '#c655d6'
};

const LoginText = styled.p`
	color: #c655d6;
	margin-bottom: 24px;
	font-weight: bold;
	text-transform: uppercase;
	text-align: center;
	font-size: 18px;

	@media (max-width: 600px) {
		margin-bottom: 4px;
	}
`;

class Register extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canSubmit: false
		};
		this.history = this.props.history;
	}
	componentDidMount() {
		document.title = 'Register | Chekkit Enterprise';
	}

	componentWillUnmount() {
		document.body.className = document.body.className.replace(
			'red-background',
			''
		);
	}

	renderError = () => {
		if (this.props.error) {
			return `* ${this.props.error}`;
		}

		return '';
	};

	render() {
		return (
			<div>
				<Header />
				<Paper zDepth={1} style={styles.paper}>
					<div className="container" style={styles.container}>
						<div className="row">
							<div className="col s12">
								<Logo src="/img/chekkit-logo.svg" />
								<LoginText>
									Register for your Chekkit Enterprise account
								</LoginText>
								<RegisterForm />
								<div className="row">
									<p
										style={{
											...styles.container,
											...styles.red
										}}
									>
										{this.renderError()}
									</p>

									<div className="row">
										<label>
											By registering in you agree to our{' '}
											<a
												href="https://www.chekkit.io/terms-of-use"
												target="_blank"
												style={link}
												rel="noopener noreferrer"
											>
												Terms of Use
											</a>{' '}
											and{' '}
											<a
												href="https://www.chekkit.io/privacy-policy"
												target="_blank"
												style={link}
												rel="noopener noreferrer"
											>
												Privacy Policy
											</a>
											.
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Paper>
				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		error: state.error
	};
}

export default connect(mapStateToProps, actions)(withRouter(Register));



// WEBPACK FOOTER //
// ./src/components/register/Register.js